import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './ProjectDetail.scss';
var renderWorkLocation = function renderWorkLocation(workLocation, shortOfficeLocation) {
  if (workLocation === 'remote') {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment work-location"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-map-marker-alt"
    }), "Remote"));
  }
  if (workLocation === 'office' || workLocation === 'both') {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment work-location"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-map-marker-alt"
    }), "Office", shortOfficeLocation && /*#__PURE__*/React.createElement("span", null, ' ', "(", /*#__PURE__*/React.createElement("strong", null, shortOfficeLocation), ")"), workLocation === 'both' && ' and Remote'));
  }
  if (workLocation === 'hybrid') {
    return /*#__PURE__*/React.createElement("div", {
      className: "commitment work-location"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-map-marker-alt"
    }), "Hybrid"));
  }
  return null;
};
function ProjectDetail(props) {
  var className = props.className,
    name = props.name,
    workCommitment = props.workCommitment,
    tags = props.tags,
    duration = props.duration,
    durationText = props.durationText,
    workLocation = props.workLocation,
    workCommitmentText = props.workCommitmentText,
    projectInvitationStatus = props.projectInvitationStatus,
    levels = props.levels,
    employmentType = props.employmentType,
    showProjectEmploymentType = props.showProjectEmploymentType;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-detail ".concat(className)
  }, showProjectEmploymentType && /*#__PURE__*/React.createElement("span", {
    className: "".concat(employmentType)
  }, capitalize(employmentType), ' ', "Position"), /*#__PURE__*/React.createElement("h3", {
    className: "mb-2"
  }, name, projectInvitationStatus && /*#__PURE__*/React.createElement("span", {
    className: "badge small invited-badge"
  }, projectInvitationStatus)), /*#__PURE__*/React.createElement("div", {
    className: "g-row g-row--wrap logistics mb-2 body-text-2 card-icons"
  }, duration && employmentType !== 'full_time' && /*#__PURE__*/React.createElement("div", {
    className: "commitment duration"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-calendar-day"
  }), ' ', durationText ? "".concat(durationText, " duration") : "".concat(duration, " month duration")), employmentType === 'consulting' && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-commitment"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-clock"
  }), workCommitmentText || "".concat(workCommitment, " hrs/week")), renderWorkLocation(workLocation), levels && /*#__PURE__*/React.createElement("div", {
    className: "commitment work-commitment"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-certificate"
  }), "".concat(levels))), /*#__PURE__*/React.createElement("div", {
    className: "tags mb-3"
  }, tags.map(function (t) {
    return /*#__PURE__*/React.createElement("span", {
      key: t,
      className: "badge small normal-font me-2"
    }, t);
  })));
}
ProjectDetail.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  workCommitmentText: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.string.isRequired,
  durationText: PropTypes.string,
  workLocation: PropTypes.string.isRequired,
  projectInvitationStatus: PropTypes.string,
  levels: PropTypes.string,
  employmentType: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool
};
ProjectDetail.defaultProps = {
  className: '',
  projectInvitationStatus: '',
  employmentType: '',
  showProjectEmploymentType: false,
  levels: '',
  workCommitmentText: '',
  durationText: ''
};
export default ProjectDetail;